import * as classnames from 'classnames/bind'
import * as React from 'react'
import Slider, { Settings } from 'react-slick'
import Icon from '../Icon/index'
import styles from './carousel.scss'

const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  settings: Settings
}

function NextArrow(props: IProps) {
  const { onClick, className } = props
  return (
    <div className={cx('carousel__nav_next', className)}>
      <div
        className={cx('next')}
        onClick={onClick}>
        <Icon type="silde-right-b" style={{ width: 'inherit', height: 'inherit' }} />
      </div>
    </div>
  )
}

function PreArrow(props: IProps) {
  const { onClick, className } = props
  return (
    <div className={cx('carousel__nav_prev', className)}>
      <div
        className={cx('prev')}
        onClick={onClick}>
        <Icon type="silde-left-b" style={{ width: 'inherit', height: 'inherit' }} />
      </div>
    </div>
  )
}

export default class CustomArrows extends React.Component<IProps> {
  public render() {
    const { className, settings, children } = this.props
    const sliderSettings = {
      ...settings,
      nextArrow: <NextArrow {...this.props} />,
      prevArrow: <PreArrow {...this.props} />
    }

    return (
      <Slider {...sliderSettings} className={cx('carousel', className)}>
        {children}
      </Slider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Carousel/carousel.tsx